import { makeStyles } from '@material-ui/core/styles';
import {
  ICON_CONTAINER_SIZE,
  ICON_CONTAINER_MARGIN_RIGHT,
  SPEED_ICON_COLOR,
  ICON_SIZE,
  TEXT_COLOR,
  FONT_SIZE_SMALL
} from '../constants/primitive-metrics.constants';

export const useMetricItemStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  iconContainer: {
    width: ICON_CONTAINER_SIZE,
    height: ICON_CONTAINER_SIZE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: ICON_CONTAINER_MARGIN_RIGHT,
  },
  icon: {
    color: SPEED_ICON_COLOR,
    fontSize: ICON_SIZE,
  },
  metricName: {
    color: TEXT_COLOR,
    fontSize: FONT_SIZE_SMALL,
    textTransform: 'uppercase',
    display: 'block',
    fontWeight: 'bold',
  },
  metricValue: {
    fontWeight: 'bold',
    fontSize: FONT_SIZE_SMALL,
  },
}));
